module.exports = __webpack_public_path__ + "img/丝路文博网_01.6e17c9c5.jpg";